import React, { useState, useEffect } from "react";
import { useApi } from "../../../api/useApi";
import { dataSourceSearch } from "../../../api/dataSourceQueries";
import debounce from "lodash.debounce";
import { FormControl, StyledSelect, Label } from "../../Form/FormControls";
import ErrorMessages from "../../Notifications/ErrorMessages";
import { dataSource } from "../../../common/paths";
import { useHistory } from "react-router-dom";
import DataSourceName from "../../Card/DataSourceName";

const SearchDataSources = ({ connectionId, action }) => {
  const [stateSources, setStateSources] = useState();
  let history = useHistory();
  const [{ errors, loading, data: sourceData }, getSources] = useApi();

  useEffect(() => {
    if (sourceData) {
      const sourceOptions = sourceData?.availableDataSources?.edges?.map(
        (ds) => {
          const s = ds?.node;
          return {
            label: s?.friendlyName ? s.friendlyName + " " + s?.name : s?.name,
            value: s?.id,
            friendlyName: s?.friendlyName,
            name: s?.name,
          };
        }
      );

      setStateSources(sourceOptions);
    } else {
      setStateSources([]);
    }
  }, [sourceData]);

  const [inputText, setInputText] = React.useState("");
  const [searchText, setSearchText] = React.useState("");
  const [tooShortWarning, setTooShortWarning] = useState(false);

  useEffect(() => {
    if (searchText.length >= 2) {
      setTooShortWarning(false);

      const baseOr = [
        { name: { contains: searchText } },
        { friendlyName: { contains: searchText } },
      ];

      const whereClause = connectionId
        ? {
            connectionId: { eq: connectionId },
            or: baseOr,
          }
        : {
            or: baseOr,
          };

      getSources({
        query: dataSourceSearch,
        variables: {
          where: whereClause,
          order: [{ friendlyName: "ASC" }],
        },
      });
    } else {
      if (searchText.length > 0) {
        setTooShortWarning(true);
      }
      setStateSources([]);
    }
  }, [searchText, getSources, connectionId]);

  const setSearchTextDebounced = React.useRef(
    debounce((searchText) => setSearchText(searchText), 500)
  ).current;

  const handleInputChangePrimary = (inputText, event) => {
    // prevent outside click from resetting inputText to ""
    if (event.action !== "input-blur" && event.action !== "menu-close") {
      setInputText(inputText);
      setSearchTextDebounced(inputText);
    }
  };

  return (
    <FormControl style={{ maxWidth: "300px" }}>
      {tooShortWarning && (
        <div
          style={{ marginBottom: "2px", color: "#cc3300", fontSize: "0.9rem" }}
        >
          Please enter at least 2 characters to search.
        </div>
      )}

      <Label>Search</Label>
      <StyledSelect
        className={`react-select-container`}
        classNamePrefix={`react-select`}
        name={`NameSearch`}
        id={`NameSearch`}
        inputId={`NameSearch-input`}
        instanceId={`NameSearch-instance`}
        label="Sources"
        options={stateSources}
        placeholder={`Source Name`}
        menuPlacement="auto"
        inputValue={inputText}
        isLoading={loading}
        onChange={(e) =>
          action ? action(e?.value) : history.push(dataSource(e?.value))
        }
        onInputChange={handleInputChangePrimary}
        menuPortalTarget={document.body}
        formatOptionLabel={(option) => (
          <div>
            <DataSourceName dataSource={option} />
          </div>
        )}
      />

      {errors ? <ErrorMessages errors={errors} /> : null}
    </FormControl>
  );
};

export default SearchDataSources;
